import React from "react";
import OfferStatusPill from "../../../Pills/OfferStatusPill/OfferStatusPill";

export default function OfferStatusCell(cell) {
  return (
    <span style={{ display: "flex", alignItems: "center" }}>
      <OfferStatusPill value={cell.value} />
    </span>
  );
}